import Modulos from '../../classes/enums/Modulos'

export default [
  {
    icon: 'bell',
    path: 'verifactu',
    name: 'verifactu',
    component: () => import('@/views/invoices/Verifactus.vue'),
    meta: { registerNavFromMenu: true, status: 99999, modules: [[Modulos.EMISION_FACTURAS], [Modulos.VERIFACTU]] }
  },
  {
    path: 'verifactu/:type/:IdCliente/:IdCifEmpresa/:NumSerieFactura/:FechaExpedicion/details',
    name: 'verifactu/details',
    component: () => import('@/views/invoices/Verifactu.vue'),
    meta: { secondaryMenu: 'verifactu', registerNavFromMenu: false, modules: [[Modulos.EMISION_FACTURAS], [Modulos.VERIFACTU]] }
  },
  {
    path: 'verifactu/:type/:IdCliente/:IdCifEmpresa/:NumSerieFactura/:FechaExpedicion/groups',
    name: 'verifactu/groups',
    component: () => import('@/views/invoices/GroupsByVerifactu.vue'),
    meta: { secondaryMenu: 'verifactu', registerNavFromMenu: false, recibida: false, modules: [[Modulos.EMISION_FACTURAS], [Modulos.VERIFACTU]] }
  },
  {
    path: 'verifactu/:type/:IdCliente/:IdCifEmpresa/:NumSerieFactura/:FechaExpedicion/historical',
    name: 'verifactu/historical',
    component: () => import('@/views/historical/VerifactuHistorical.vue'),
    meta: { secondaryMenu: 'verifactu', registerNavFromMenu: false, modules: [[Modulos.EMISION_FACTURAS], [Modulos.VERIFACTU]] }
  },
]
